import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { AppConfig } from 'src/app/app.config';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/Operators';
@Injectable({
  providedIn: 'root'
})
export class CadreService {
  cadreUrl: string;
  constructor(private http: HttpClient, private config: AppConfig) {
    this.cadreUrl = this.config.apiUrl + "MasterDataApi";
  }
  private handleError(error: HttpErrorResponse) {
    return throwError(error.error);
  }
  headers = new HttpHeaders({
    'Content-Type': 'application/json',
  });
  getCadres() {
    return this.http.get(this.cadreUrl + "/" + "GetCadres").pipe(
      catchError(this.handleError)
    );
  }
}
